/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_LanguageInputs */

const en_mk_foot_language = /** @type {(inputs: Mk_Foot_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const id_mk_foot_language = /** @type {(inputs: Mk_Foot_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Mk_Foot_LanguageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_language = /** @type {((inputs?: Mk_Foot_LanguageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_LanguageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_language(inputs)
	return en_mk_foot_language(inputs)
});